module.exports = __webpack_public_path__ + "static/media/icon-trash-grey.a1be7410.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/icon-trash-grey.svg
// module id = 950
// module chunks = 0